import slice from './slice';

export const { 
  resetState,
  setSelectedDrone,
} = slice.actions;